// TODO: move to core-ui
import { RefObject, useEffect } from "react";

const useResizeObserver = (ref: RefObject<Element>, onResize?: (height: number) => void) => {
    useEffect(() => {
        const el = ref.current;
        if (!el || !onResize || typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver((entries) => {
            onResize(entries[0]?.contentRect.height ?? 0);
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, [ref, onResize]);
};

export default useResizeObserver;
